import { SpaceXxs, SpaceXs, SpaceXl } from "@nxt-costco-com/forge-design-tokens";
const mdoIconStyles = {
  height: SpaceXl,
  width: SpaceXl
};
const mdoWrapperStyles = {
  cursor: "default",
  display: "flex",
  flexWrap: "nowrap",
  gap: SpaceXs
};
const mdoTextDivStyles = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: SpaceXxs
};
const mdoContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs
};
export {
  mdoContainerStyles,
  mdoIconStyles,
  mdoTextDivStyles,
  mdoWrapperStyles
};
